import React from 'react'
import Header from "../components/layout/Header"
import Order from "../components/blocks/Order"
import classes from "../components/layout/Layout/Layout.module.scss"
import {useAppSelector} from "../hooks/redux"
import {USER_ROLE_ADMIN, USER_ROLE_MANAGER} from "../utils/constants/userRoles"
import DriverOrder from "../components/blocks/DriverOrder/DriverOrder"

export default function OrderPage() {

  const {role_id} = useAppSelector(state => state.auth.user)
  const isExtendedOrder = role_id === USER_ROLE_ADMIN || role_id === USER_ROLE_MANAGER

  return (
    <>
      <div className={classes.header}>
        <Header title={'Заявки'} showUser={true}/>
      </div>
      <div className={classes.content}>
        {isExtendedOrder ? <Order/>: <DriverOrder/>}
      </div>
    </>
  )
}